import { IconCheck } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

import { config } from 'src/config'
import colorVariables from 'src/styles/Colors.module.scss'

import styles from './SubscriptionPerks.module.scss'

export const SubscriptionPerks = () => {
  const { t } = useTranslation()

  const text = [
    t('pdp.subscription.perk1'),
    t('pdp.subscription.perk3', { amount: config.shippingFreeFrom }),
    t('pdp.subscription.perk2'),
    t('pdp.subscription.perk4'),
  ]

  return (
    <div className={styles.container}>
      <div className={styles.perkColumn}>
        {text.slice(0, 2).map((content) => (
          <div key={content} className={styles.perk}>
            <IconCheck size={18} color={colorVariables['color-success-primary']} className={styles.icon} />
            {content}
          </div>
        ))}
      </div>
      <div className={styles.perkColumn}>
        {text.slice(2, 4).map((content) => (
          <div key={content} className={styles.perk}>
            <IconCheck size={18} color={colorVariables['color-success-primary']} className={styles.icon} />
            {content}
          </div>
        ))}
      </div>
    </div>
  )
}
